<template>
  <v-form v-model="valid" ref="mainForm">
    <CarteIdentification :identification="identification" class="mb-6" />
    <DatePickerLive
      code="date_naissance"
      v-model="sasContact.dateNaissance"
      :live="liveSasContact(5704)"
      :maxValue="convertDateToString(new Date())"
    />
    <CatalogueLive code="sexe" v-model="sasContact.sexe" :live="liveSasContact(5705)" />
    <FileInput code="photographie" :file="sasContact.photo" :live="liveSasContact(5711)" :accepts="this.$constants.ACCEPTED_FORMATS.AVATAR" />
    <FileInput code="acte_de_naissance" :file="sasContact.acteDeNaissance" :live="liveSasContact(5712)" />

    <CatalogueLive code="autres_noms_ouinon" :live="liveSasContact(5706)" v-model="sasContact.avezVousDejaUtiliseDAutresNoms" />
    <TextFieldLive
      code="autres_noms_lesquels"
      v-model="sasContact.anciensNoms"
      :live="liveSasContact(5707)"
      :opq-if="estOui(sasContact.avezVousDejaUtiliseDAutresNoms)"
    />
    <DatePickerLive
      code="autres_noms_date"
      v-model="sasContact.dateModificationNom"
      :live="liveSasContact(5708)"
      :opq-if="estOui(sasContact.avezVousDejaUtiliseDAutresNoms)"
      :maxValue="serverDate()"
    />
    <FileInput
      code="autres_noms_preuve"
      :file="sasContact.preuveChangementDeNom"
      :live="liveSasContact(5709)"
      :opq-if="estOui(sasContact.avezVousDejaUtiliseDAutresNoms)"
      @file-deleted="sasContact.preuveChangementDeNom = null"
    />
  </v-form>
</template>

<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import SasContact from "@/mixins/SasContact"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import CarteIdentification from "@/components/form_parts/CarteIdentification.vue"

export default {
  components: { CarteIdentification },
  mixins: [StepFormWithValidation, CataloguesHelpers, DatesHelpers, SasContact],

  props: {
    sas: { type: Object }
  },
  computed: {
    identification() {
      return this.sas.identification
    },
    sasEquivalence() {
      return this.sas.sasEquivalence
    }
  },
  methods: {
    liveSasEquivalence(cle) {
      return { endpoint: "sas-equivalence", cle: cle, fileId: this.sasEquivalence.id }
    }
  }
}
</script>

<style>
</style>